module.exports = __webpack_public_path__ + "img/solar-system.a36998f8.svg";